import reducer from './reducers';

import tourWatcher, * as tourOperations from './operations';
import * as tourSelectors from './selectors';
import * as tourTypes from './types';

export { tourOperations, tourSelectors, tourTypes, tourWatcher };

export default reducer;
